import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'
import { combineLatest, map } from 'rxjs'

import { decodeTokenCustomerId } from '../../auth/scope'
import { latestAuthStateWithAccessToken$ } from '../../auth/state'

export type OnboardingRequestState =
  | {
      name: 'initial'
    }
  | { name: 'signup_loading' }
  //TODO: add response type
  | { name: 'signup_complete'; response: unknown }
  | { name: 'signup_error'; error: Error }

export const [onboardingRequestState$, setOnboardingRequestState] =
  createSignal<OnboardingRequestState>()

export const [useOnboardingRequestState, latestOnboardingRequestState$] = bind(
  combineLatest([onboardingRequestState$, latestAuthStateWithAccessToken$]).pipe(
    map(([onboardingState, authState]) => {
      return authState.isAuthenticated &&
        decodeTokenCustomerId(authState.accessToken) &&
        onboardingState.name !== 'signup_complete'
        ? ({ name: 'signup_complete', response: null } as OnboardingRequestState)
        : onboardingState
    }),
  ),
  { name: 'initial' },
)

export const formDisabledStates: ReadonlyArray<OnboardingRequestState['name']> = [
  'signup_loading',
  'signup_complete',
]

export const formProcessingStates: ReadonlyArray<OnboardingRequestState['name']> = [
  'signup_loading',
]
